module.exports = __webpack_public_path__ + "img/1-5.3d1c8a75.svg";